var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"has-border",attrs:{"disable-sort":"","headers":_vm.headers,"items":_vm.listItems,"search":_vm.search},scopedSlots:_vm._u([{key:"item.domain",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.Referer || 'No Referer')+" ")]}},{key:"item.bandwidth",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.Bandwidth)+" ")]}},{key:"item.requestTime",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.Request)+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }